exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".focused-input-image[data-v-75442c4a] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.focused-input-image object[data-v-75442c4a] {\n  max-height: 250px;\n  max-width: 380px;\n}\n@media (max-width: 1199px) {\n.parameters-flat .focused-input-image[data-v-75442c4a] {\n    padding: 0 50px;\n}\n}\n@media (max-width: 991px) {\n.parameters-flat .focused-input-image[data-v-75442c4a] {\n    padding: 0;\n}\n}\n", ""]);

// exports
